module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.driver !== null) ? _c('div', {
    staticClass: "component-driver-profile"
  }, [_vm._m(0), _c('div', {
    staticClass: "driver-profile tabs-inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('driver', {
    attrs: {
      "type": 'driver-data',
      "item": _vm.driver
    }
  })], 1)]), _c('hr'), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('h2', [_vm._v("Groups")]), _vm._l((_vm.driver.groups), function(group) {
    return _c('DriverGroup', {
      attrs: {
        "item": group,
        "driver": _vm.driver
      },
      on: {
        "toggleSupervisor": _vm.toggleSupervisor
      }
    })
  })], 2)])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action-bar"
  }, [_c('h2', [_vm._v("Driver Profile")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-13786095!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/tabbed/DriverProfile.vue
// module id = 2156
// module chunks = 1